import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function BibliotekaIcon({ size, title, gradient, className, ...rest }: SvgIconProps) {
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(rest);

  // Prevent <linearGradient id="..."> collisions when multiple icons are rendered.
  const gradientId = React.useId();
  const stroke = gradient ? `url(#${gradientId})` : "currentColor";

  return (
    <svg
      viewBox="0 0 16 16"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}

      {gradient ? (
        <defs>
          <linearGradient
            id={gradientId}
            x1="0"
            y1="0"
            x2="16"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B20BFF" />
            <stop offset="1" stopColor="#0059FF" />
          </linearGradient>
        </defs>
      ) : null}

      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m1.5 8.243 6.267 3.028c.086.041.128.062.173.07q.06.01.12 0c.045-.008.087-.029.173-.07L14.5 8.243m-13 2.617 5.777 2.79c.265.129.398.193.536.217a1 1 0 0 0 .37-.006c.137-.028.268-.096.529-.232l5.788-3.012m-13-5.514 6.267-3.028c.086-.04.128-.062.173-.07a.3.3 0 0 1 .12 0c.045.008.087.03.173.07L14.5 5.103 8.233 8.131a.7.7 0 0 1-.173.07.3.3 0 0 1-.12 0 .7.7 0 0 1-.173-.07z"
      />
    </svg>
  );
}

export default BibliotekaIcon;
